import { Link } from 'gatsby';
import React from 'react';
import { shouldOpenJoinModal } from './buttonHandlers';

export default function LinkComponent({ to, children, ...other }) {
	// Check if this is a "Join Now" button by examining children
	const isJoinNowButton = React.Children.toArray(children).some((child) => {
		if (React.isValidElement(child) && child.props.buttonName) {
			return shouldOpenJoinModal(child.props.buttonName);
		}
		return false;
	});

	// For "Join Now" buttons, render as a div to prevent navigation
	// This ensures the button works regardless of what link is set in Strapi
	if (isJoinNowButton) {
		return <div {...other}>{children}</div>;
	}

	// Return null if to is not provided for regular buttons
	if (!to || to.trim() === '') {
		return null;
	}

	const internal = /^\/(?!\/)/.test(to);

	// Check if the URL contains a hash fragment
	const hasHash = to.includes('#');

	// Handle click for internal links to ensure proper scrolling in Firefox
	const handleInternalClick = (e) => {
		// Detect Firefox browser
		const isFirefox =
			typeof window !== 'undefined' &&
			window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

		if (isFirefox && !hasHash) {
			// For Firefox, ensure scroll to top happens immediately
			window.scrollTo(0, 0);
			if (document.documentElement) {
				document.documentElement.scrollTop = 0;
			}
			if (document.body) {
				document.body.scrollTop = 0;
			}
		}

		// Call the original onClick handler if it exists
		if (other.onClick) {
			other.onClick(e);
		}
	};

	if (internal) {
		// If target="_blank" is provided, use a regular anchor tag to support opening in new tab
		// If it's an internal link with a hash fragment, use a regular anchor tag
		// The gatsby-browser.js will handle the hash navigation
		if (hasHash || other.target === '_blank') {
			return (
				<a href={to} {...other}>
					{children}
				</a>
			);
		}
		// For internal links without hash fragments, use Gatsby's Link component
		return (
			<Link to={to} {...other} onClick={handleInternalClick}>
				{children}
			</Link>
		);
	} else {
		return (
			<a href={to} {...other}>
				{children}
			</a>
		);
	}
}
